import React from "react";
import { ArrowRight } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
function CategoriesGridConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {[1, 2, 3].map(i => <div key={i} className="relative overflow-hidden rounded-xl bg-muted" data-index={i}>
            <AspectRatio ratio={1}>
              <div className="h-full w-full animate-pulse bg-muted-foreground/10" />
            </AspectRatio>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-destructive">Impossibile caricare le categorie.</div>;
  }
  if (!terms || terms.length === 0) {
    return null;
  }
  const displayTerms = terms.slice(0, 3);
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
      {displayTerms.map((term, i) => <Link key={term.id} to="/OurSweetsPage#tutti-i-nostri-dolci" className="group relative block overflow-hidden rounded-xl shadow-md transition-shadow hover:shadow-xl" data-index={i}>
          <AspectRatio ratio={1}>
            {}
            <div className="absolute inset-0 h-full w-full">
              <img src={term.image_url || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562811/img/generic_sweets_placeholder.png"} alt={term.name} className="h-full w-full object-cover transition-transform duration-700 will-change-transform group-hover:scale-110" loading="lazy" />
            </div>

            {}
            <div className="absolute inset-0 bg-black/30 transition-colors duration-300 group-hover:bg-black/50" />

            {}
            <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center">
              <h3 className="font-serif text-3xl font-bold text-white drop-shadow-md md:text-4xl">
                {term.name}
              </h3>
              
              {}
              <div className="mt-6 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100 translate-y-0 opacity-100 md:translate-y-4 md:opacity-0">
                {i === 0 ? <Link to="/OurSweetsPage#tutti-i-nostri-dolci">
                    <Button variant="secondary" className="gap-2 font-sans font-medium shadow-sm">
                      Scopri di più
                      <ArrowRight className="h-4 w-4" />
                    </Button>
                  </Link> : i === 1 ? <Link to="/OurSweetsPage#tutti-i-nostri-dolci">
                    <Button variant="secondary" className="gap-2 font-sans font-medium shadow-sm">
                      Scopri di più
                      <ArrowRight className="h-4 w-4" />
                    </Button>
                  </Link> : <Link to="#vetrina-delle-torte-dautore">
                    <Button variant="secondary" className="gap-2 font-sans font-medium shadow-sm">
                      Scopri di più
                      <ArrowRight className="h-4 w-4" />
                    </Button>
                  </Link>}
              </div>
            </div>
          </AspectRatio>
        </Link>)}
    </div>;
}
export default function TasteCategories() {
  const query = new WP_Term_Query({
    taxonomy: "product_cat",
    per_page: 3,
    orderby: "count",
    order: "desc"
  });
  return;
}